/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FlexRow } from 'sarsaparilla';
import { withCompatRouter } from 'sarsaparilla/legacy';

import * as tripPlannerActions from '../actions/tripPlanner';
import TripItineraryContainer from './TripItineraryContainer';
import TripContentSearchResultsContainer from './TripContentSearchResultsContainer';
import TripPlannerOverviewModal from '../components/TripPlannerOverviewModal';
import TripPlannerBookModal from '../components/TripPlannerBookModal';

const propTypes = {
    router: PropTypes.any,
    dispatch: PropTypes.func,
    tripPlanner: PropTypes.object,
};

export class TripContentContainer extends React.Component {
    componentDidMount() {
        document.body.classList.add('rec-no-overflow-y');
        this.refresh();
    }

    componentWillUnmount() {
        document.body.classList.remove('rec-no-overflow-y');
    }

    refresh() {
        const tripId = this.props.router.params.tripId;

        if (tripId !== this.props.tripPlanner.trip.trip_id) {
            this.props.dispatch(tripPlannerActions.resetResults());
            this.props.dispatch(tripPlannerActions.loadTrip(tripId));
        }
    }

    render() {
        return (
            <div className="rec-page">
                <FlexRow hasGutters={false} className="trip-planner-content-container">
                    <h1 className="rec-sr-only">Trip Planner</h1>
                    <h2 className="rec-sr-only">Trip Details</h2>
                    <TripContentSearchResultsContainer />
                    <TripItineraryContainer />
                    <TripPlannerBookModal />
                </FlexRow>
                <TripPlannerOverviewModal />
            </div>
        );
    }
}

TripContentContainer.propTypes = propTypes;

function select(state) {
    return {
        tripPlanner: state.tripPlanner,
    };
}

export default withCompatRouter(connect(select)(TripContentContainer));
